<template>
  <v-autocomplete
    ref="autocomplete"
    :value="value"
    :label="label"
    :items="fullItems"
    :hide-details="hideDetails"
    :error-messages="errorMessages"
    attach
    no-filter
    dense
    :chips="multipleSelect ? true : false"
    :small-chips="multipleSelect ? true : false"
    :deletable-chips="multipleSelect ? true : false"
    :multiple="multipleSelect ? true : false"
    clearable
    item-text="title"
    item-value="id"
    return-object
    v-bind="$attrs"
    outlined
    :search-input.sync="search"
    open-on-clear
    no-data-text="Даних немає"
    @change="search = ''"
    @input="onInput"
    @focus="onFocus"
    @click:clear="onClear"
  >
    <template v-slot:item="{ item }">
      <v-list-item-content :style="colorFn(item)">
        <InfiniteScroll @intersect="handleScroll(item.id)" />
        <v-list-item-title v-text="item.title" />
      </v-list-item-content>
    </template>
    <template v-if="append" v-slot:append>
      <component
        :is="componentName"
        :value="value"
        @add="add"
        @close-menu="closeMenuList"
      />
    </template>
  </v-autocomplete>
</template>

<script>
import InfiniteScroll from "@/components/InfiniteScroll";
import DropdownMenu from "../../views/document-blocks/DropdownMenu.vue";

export default {
  name: "LazyAutocomplete",
  components: {
    InfiniteScroll,
    DropdownMenu,
  },
  props: {
    value: {
      type: [Object, String, Array],
    },
    label: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    totalItems: {
      type: Number,
      default: 0,
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    errorMessages: {
      type: Array,
    },
    colorFn: {
      type: Function,
    },
    multipleSelect: {
      type: Boolean,
      default: false,
    },
    componentName: {
      type: String,
      default: "",
    },
    append: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    search: null,
    debounceTime: null,
    currentPage: 1,
    perPage: 9,
    menu: false,
  }),
  computed: {
    fullItems() {
      const items = this.items.filter(
        (item, index, arr) =>
          arr.findIndex(({ id }) => item.id === id) === index
      );
      if (Array.isArray(this.value)) {
        return this.value.concat(items);
      } else if (typeof this.value === "object") {
        return this.value ? [this.value, ...items] : items;
      } else {
        return items;
      }
    },
  },
  watch: {
    search(newVal, oldVal) {
      if (
        this.fullItems.some((item) => item?.title === newVal) ||
        (!oldVal && !newVal)
      )
        return;
      this.debounce();
    },
  },

  methods: {
    handleScroll(id) {
      if (this.totalItems <= this.fullItems.length) return;
      const position = this.fullItems.findIndex((item) => item.id === id);

      if (position === this.fullItems.length - 2) {
        this.getMoreItems();
      }
    },
    debounce() {
      clearTimeout(this.debounceTime);
      this.debounceTime = setTimeout(() => {
        this.onSearch(this.search);
      }, 500);
    },
    onInput(value = "") {
      if (value) {
        this.multipleSelect ? false : this.$refs.autocomplete.blur();
        this.$emit("input", value);
      }
    },
    onSearch(payload) {
      this.search = payload;
      this.currentPage = 1;
      this.$emit("update:items", []);
      this.getItems();
    },
    onClear() {
      this.$emit("input", null);
    },
    onFocus() {
      this.currentPage = 1;
      this.search = "";
      this.getItems();
    },
    getMoreItems() {
      this.currentPage += 1;
      this.getItems();
    },
    getItems() {
      this.$emit("getItems", {
        currentPage: this.currentPage,
        perPage: this.perPage,
        search: this.search,
      });
    },
    add(valueId) {
      this.$emit("add", valueId);
    },
    closeMenuList() {
      this.$children[0].isMenuActive = false;
    },
  },
};
</script>
